import React from "react";
import { SectionTitle } from "components/items";
import makeTitle from "function/makeTitle.js";

const sectionTitle = [
	{
		text: "FACTORY",
		color: "defualt",
		break: false,
	},
	{
		text: "INFORMATION",
		color: "main",
		break: false,
	},
];

const infoList = [
	{
		id: 1,
		title: "주요 생산품",
		text: ["CP 비누, 고체샴푸바, 린스바, 약산성비누, 입욕제"],
	},
	{
		id: 2,
		title: "공장 주소",
		text: ["제 1공장: 경기도 하남시 풍산동 489 미사테스타타워 FB329호, FB330호, FB331호, FB332호", "제 2공장: 경기도 하남시 하남대로 990 로얄팰리스 테크노1차 지하2층(B206)"],
	},
	{
		id: 3,
		title: "생산 및 가공인원",
		text: ["50명 이상", "(발달장애인 직원 50%이상)"],
	},
	{
		id: 6,
		title: "인증 및 허가",
		text: ["ISO 14001, ISO 9001, 장애인표준사업장, 미국USDA유기농 화장품 제조사 인증,유기농인증, 프랑스 EVE VEGAN 비건 화장품 제조사 인증"],
	},

	{
		id: 5,
		title: "월 생산량",
		text: ["비누: 400,000개", "입욕제: 60,000개"],
	},
];
const FactoryInformation = (props) => {
	return (
		<section className={`FactoryInformation ${props.className}`}>
			<div className="section-header">
				<div className="con">
					<SectionTitle text={makeTitle(sectionTitle)} type="center" />
				</div>
			</div>
			<div className="section-contents">
				<div className="con">
					<ul className="wrap-info">
						{infoList.map((el) => {
							return (
								<li className="info-list" key={el.id}>
									<h5>{el.title}</h5>
									<div className="wrap-body">
										{el.text.map((t, index) => {
											return <p key={index}>{t}</p>;
										})}
									</div>
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		</section>
	);
};

export default FactoryInformation;
